<template>
	<label class="BaseRadio">
		<input
			type="radio"
			class="BaseRadio-input"
            :name="name"
			:checked="modelValue"
			@change="$emit('update:modelValue', $event.target.checked)"
		>
		<span class="BaseRadio-label" v-if="label">{{ label }}</span>
	</label>
</template>

<script>
export default {
	name: 'BaseRadio',
	props: {
		modelValue: {
			type: Boolean,
			default: false
		},
        name: String,
		label: String
	}
}
</script>

<style lang="scss" scoped>
.BaseRadio {
	display: flex;
	margin-top: 1em;

	&:first-child {
		margin-top: 0;
	}

	&-input {
		-moz-appearance: none;
		-webkit-appearance: none;
		appearance: none;
		width: 1.2em;
		height: 1.2em;
		border: .2em solid var(--colorBrand);
		box-shadow: inset 0 0 0 .15em #fff;
		outline: none;
		margin: .214em 0 0;
		border-radius: 50%;

		&:checked {
			background: var(--colorBrand);
		}
	}

	&-label {
		flex: 1;
		margin-left: .8em;
	}
}
</style>
